<template>
  <UIModal v-model="store.userBlockInfoModalOpen">
    <template #header>
      <h2 class="tw:font-bold tw:text-white tw:text-3xl tw:text-center">{{ $t('blockUserInfoTitle') }}</h2>
    </template>
    <template #default>
      <div class="tw:p-6 tw:max-w-[500px] tw:text-center">
        <p class="tw:text-xl">{{ $t('blockUserInfoText') }}</p>
      </div>
    </template>
  </UIModal>
</template>

<script lang="ts" setup>
const store = useMainStore();
</script>
